import React, { useEffect, useState } from "react";

// STYLES
import {
  BackToGuidesButton,
  BackToGuidesImage,
  TitleWrapper,
  LegislationOrdersContainer,
  ContentWrapper,
  BackToGuidesWrapper,
  NoDataContainer,
  SvgContainer,
} from "./LegislationOrdersStyled";

// LIBRARIES
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

//ASETS
import LeftArrow from "assets/icons/ArrowLeftHovered.svg";
import { ReactComponent as NoDataDark } from "assets/svg/NoDataDark.svg";

// MISC
import { COLORS } from "constants/variables";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { DownloadFileType } from "components/Atoms/DownloadFileAtom/DownloadFileAtomModel";
import { appRoutes } from "config/AppRoutesConfig";
import { DSUORdersData } from "constants/mocks/DSUOrders";
import legislationService from "services/legislationService";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// HOOKS
import usePagination from "hooks/usePagination";

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import Pagination from "components/Atoms/Paginations/Pagination";
import DownloadFileAtom from "components/Atoms/DownloadFileAtom/DownloadFileAtom";
import formatDate from "utils/formatDate";

// CONFIGURATION

const LegislationOrders = () => {
  // PROPERTIES

  // API REQUESTS

  // LIBRARY CONSTANTS
  const navigate = useNavigate();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const { t } = useTranslation();
  // STATE CONSTANTS
  const [orders, setOrders] = useState<any>(null);

  // LIFE CYCLE
  useEffect(() => {
    legislationService
      .getOrders()
      .then((response) => {
        // console.log("getOrders response", response);
        setOrders(response);
      })
      .catch((err) => {
        console.log("getOrders error", err);
      });
  }, []);

  const ordersData =
    orders?.data.map((file: any) => ({
      id: file?.id,
      title: file?.attributes?.title,
      //date: formatDate(file?.attributes?.date.split(), null, "ro"),
      date: file?.attributes?.date,
      pdfUrl: `${process.env.REACT_APP_UPLOAD_URL}${file?.attributes.documents.data[0]?.attributes?.attached_document?.data?.attributes?.url}`,
    })) || [];

  const { currentPage, totalPages, currentData, handlePageChange } =
    usePagination(ordersData, 15);

  // EVENT HANDLERS

  return (
    <LegislationOrdersContainer>
      <BackToGuidesWrapper
        biggerCursor={biggerCursor}
        onClick={() => navigate(appRoutes.legislation)}
      >
        <BackToGuidesImage src={LeftArrow} alt="backIcon" />
        <BackToGuidesButton>
          <CustomText
            text={t("view.legislationOrders.button")}
            type={TextType.H5boldspaced}
            color={COLORS.RaisinBlack}
          />
        </BackToGuidesButton>
      </BackToGuidesWrapper>

      <TitleWrapper>
        <CustomText
          type={TextType.H2}
          text={t("view.legislationOrders.title")}
        />
      </TitleWrapper>

      <ContentWrapper>
        {currentData.length > 0 ? (
          currentData.map((file) => (
            <DownloadFileAtom
              key={file.id}
              type={DownloadFileType.Orders}
              title={file.title}
              // institution={file.institution}
              date={file.date}
              pdfUrl={file.pdfUrl}
            />
          ))
        ) : (
          <NoDataContainer>
            <SvgContainer>
              <NoDataDark />
            </SvgContainer>
            <CustomText
              text={t("app.noData")}
              type={TextType.H4}
              color={COLORS.MetalicSilver}
            />
          </NoDataContainer>
        )}
      </ContentWrapper>

      {totalPages > 1 && (
        <Pagination
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      )}
    </LegislationOrdersContainer>
  );
};

export default LegislationOrders;
